export let qualificationInfoReqDTO = {
  qualificationtypecode: "",
  qualificationnamecode: "",
  schoolName: "",
  subjectLookupId: "",
  otherSubject: "",
  statecode: "",
  universitycode: "",
  typeResult: "",
  resultDate: "",
  attempts: "",
  percentageGrade: "",
  courseDurationMonths: "",
  certificationGrade: "",
  classGradeLookupId: "",
  modeLookupId: "",
  compulsorySubjects: "",
  optionalSubjects: "",
  councilId: "",
  councilRegistrationDate: "",
  councilRegistrationNumber: "",
  councilRenewalDate: "",
  registrationDate: "",
  registrationNumber: "",
  projectTitle: "",
  publicationType: "",
  publicationAuthorName: "",
  isPublicationFirstAuthor: "",
  publicationAuthorType: "",
  publicationJournalDetails: "",
  publicationYear: "",
  isImpactIndex2Or0OrMore: "",
  publicationPaperTitle: "",
  recognitionDate: "",
  noStudentsRegisteredYw: "",
  noStudentsResearchComplete: "",
  noStudentsPhdAwarded: "",
  isDelete: false,
  indexingBodyLookupId: "",
  articleTypeLookupId: "",
  publicationAcceptanceDate: "",
  publicationPublishedDate: "",
  isImpactIndex20OrMore: "",
  seatNumber: "",
  yearOfPassing: "",
  guidedBy: "",
  subject: "",
  qualificationname: "",
  internshipFromDate: "",
  internshipToDate: "",
  internshipCollege: "",
  internshipCertificate: "",
  internshipIssueDate: "",
  internshipIssuedBy: "",
};


// export let qualificationInfoReqDTO = {
//   qualificationtypecode: 123,
//   qualificationnamecode: 123,
//   schoolName: 123,
//   subjectLookupId: "",
//   otherSubject: "",
//   statecode: "",
//   universitycode: "",
//   typeResult: "",
//   resultDate: "",
//   attempts: "",
//   percentageGrade: "",
//   courseDurationMonths: "",
//   certificationGrade: "",
//   classGradeLookupId: "",
//   modeLookupId: "",
//   compulsorySubjects: "",
//   optionalSubjects: "",
//   councilId: "",
//   councilRegistrationDate: "",
//   councilRegistrationNumber: "",
//   councilRenewalDate: "",
//   registrationDate: "",
//   registrationNumber: "",
//   projectTitle: "",
//   publicationType: "",
//   publicationAuthorName: "",
//   isPublicationFirstAuthor: "",
//   publicationAuthorType: "",
//   publicationJournalDetails: "",
//   publicationYear: "",
//   isImpactIndex2Or0OrMore: "",
//   publicationPaperTitle: "",
//   recognitionDate: "",
//   noStudentsRegisteredYw: "",
//   noStudentsResearchComplete: "",
//   noStudentsPhdAwarded: "",
//   isDeleted: false,
//   indexingBodyLookupId: "",
//   articleTypeLookupId: "",
//   publicationAcceptanceDate: "",
//   publicationPublishedDate: "",
//   guidedBy: "",
// };

// // Replace empty strings with 123 dynamically
// Object.keys(qualificationInfoReqDTO).forEach((key) => {
//   if (qualificationInfoReqDTO[key] === "") {
//     qualificationInfoReqDTO[key] = 123;
//   }
// });
